import React from 'react';
import './ClientDetailsBlock.scss';
import PropTypes from 'prop-types';
import moment from 'moment';
import defaultUser from '../../../../../assets/images/defaultUser.jpg';
import { getLabelFromValues } from '../../../../../helpers/chartHelper';
import { stageMapperObjectForOne } from '../../../../../helpers/Mappers';

/* import user from '../../../../../assets/images/dummy-user.jpg'; */

const likelyHoodClassMapper = [
  { label: 'green', value: 'VERY_LIKELY' },
  { label: 'yellow', value: 'LIKELY' },
  { label: 'red', value: 'NOT_LIKELY' },
];

function ClientDetailsBlock({ opportunity }) {
  const {
    profilePicUrl,
    email,
    companyName,
    followUp,
    firstName,
    lastName,
    stage,
    title,
    phone,
    likelyHood,
    activeSequenceId,
    sequenceEnrollmentId,
    sequenceDetails,
  } = opportunity;
  const today = moment(Date.now()).format('DD/MM/YYYY');
  const followUpDate = moment(followUp).format('DD/MM/YYYY');
  const isEnrolledInSequence = Boolean(activeSequenceId && sequenceEnrollmentId);

  // Calculate progress percentage for visual indicator
  const progressPercentage = sequenceDetails
    ? Math.round((sequenceDetails.completedSteps / sequenceDetails.totalSteps) * 100)
    : 0;

  return (
    <div
      className={`common-block upcoming-action-block-size cursor-pointer ${getLabelFromValues(
        likelyHood,
        likelyHoodClassMapper
      )} ${!likelyHood && 'blue'}`}
      title="Click to view details"
    >
      <div className="status-color" />
      <div className="common-block--detail-container">
        <div className="DP-name-container container-height">
          <img className="user-dp" src={profilePicUrl || defaultUser} alt={`${firstName} ${lastName}`} />
          <div>
            <div>
              <div className="client-name-row">
                <div className="common-subtitle client-name ellipsis">
                  {firstName} {lastName}
                </div>
                {isEnrolledInSequence && sequenceDetails && (
                  <span
                    className={`sequence-badge sequence-badge-${sequenceDetails.status}`}
                    title={`${sequenceDetails.sequenceName} - Step ${sequenceDetails.currentStepNumber} of ${sequenceDetails.totalSteps}`}
                  >
                    <i className="fas fa-project-diagram"></i> {sequenceDetails.currentStepNumber}/{sequenceDetails.totalSteps}
                  </span>
                )}
              </div>
              <div className="common-content client-designation placeholder-color ">
                {title?.length + companyName?.length > 100 ? (
                  <div className="hide-detail">
                    {title}
                    {`${title && companyName ? ', ' : ''}`}
                    {companyName}
                  </div>
                ) : (
                  <div className="hide-detail">
                    {title}
                    {`${title && companyName ? ', ' : ''}`}
                    {companyName}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="client-other-details">
          <div className="content-title ellipsis">PHONE</div>
          <div className="common-content placeholder-color ellipsis">{phone}</div>
          <div className="content-title ellipsis">EMAIL</div>
          <div className="common-content placeholder-color ellipsis">{email}</div>
          <div className="content-title ellipsis">STAGE</div>
          <div className="common-content placeholder-color ellipsis">
            {getLabelFromValues(stage, stageMapperObjectForOne)}
          </div>
          <div className="content-title">FOLLOW UP DATE</div>
          <div
            className={`common-content ellipsis ${
              followUpDate < today ? 'font-danger' : 'placeholder-color'
            }`}
          >
            {followUp ? followUpDate : ''}
          </div>
        </div>
        {isEnrolledInSequence && sequenceDetails && (
          <div className="sequence-progress-section">
            <div className="sequence-progress-header">
              <div className="sequence-name ellipsis" title={sequenceDetails.sequenceName}>
                <i className="fas fa-project-diagram"></i> {sequenceDetails.sequenceName}
              </div>
              <div className="sequence-step-info">
                Step {sequenceDetails.currentStepNumber} of {sequenceDetails.totalSteps}
              </div>
            </div>
            <div className="progress-bar-container">
              <div
                className="progress-bar-fill"
                style={{ width: `${progressPercentage}%` }}
                title={`${progressPercentage}% complete`}
              />
            </div>
            <div className="sequence-step-name ellipsis" title={sequenceDetails.currentStepName}>
              {sequenceDetails.currentStepName}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
ClientDetailsBlock.propTypes = {
  opportunity: PropTypes.shape({
    _id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    companyName: PropTypes.string,
    email: PropTypes.string,
    profilePicUrl: PropTypes.string,
    stage: PropTypes.string,
    title: PropTypes.string,
    followUp: PropTypes.string,
    phone: PropTypes.string,
    likelyHood: PropTypes.string,
    activeSequenceId: PropTypes.string,
    sequenceEnrollmentId: PropTypes.string,
    sequenceDetails: PropTypes.shape({
      sequenceName: PropTypes.string,
      currentStepNumber: PropTypes.number,
      currentStepName: PropTypes.string,
      totalSteps: PropTypes.number,
      completedSteps: PropTypes.number,
      status: PropTypes.string,
      nextActionDate: PropTypes.string,
    }),
  }).isRequired,
};

export default ClientDetailsBlock;
